<template>
    <Policy />
</template>
<script>
import Policy from './Policy.vue';

export default {
  name: 'Setting',

  /** Components */
  components: {
    Policy,
  },
}
</script>